// eslint-disable-next-line id-length
import _ from 'lodash';
import { createStore } from 'vuex';

import actions from '@/shared/store/actions';
import Api from '@/shared/services/bright_finder';
import mutations from '@/shared/store/mutations';
import SegmentService from '@/shared/services/analytics/SegmentService';
import sharedState from '@/shared/store/state';

const parentState = {
  expandAppBarSmAndDown: false,
  familyFacingFormSchemas: [],
  familyRequestableFormSchemas: [],
  group: { favorites: [], id: null, members: [] }, // TODO: Look at deleting, we don't use it anywhere
  is_authenticated: false,
  is_anonymous: false,
  is_parent: null,
  languages: [],
  newMessage: false,
  role: 'parent',
  search_id: null,
  site: null,
  siteWebpageId: null,
  userSessionTimeout: null,
  userSessionActionTimestamp: null,
};

const defaultState = {
  ...sharedState,
  ...parentState,
};

export const definition = {
  actions: {
    ...actions,

    async identify(context, args = {}) {
      if (args.profile && args.profile.organization_id === window.organization_id) {
        context.commit('setAuthenticated', true);
        context.dispatch('setProfileAndTimeout', args.profile);
        if (args.success) args.success();
        return;
      }

      const resp = await (args.api || Api).member.session.get('parent');

      if (resp.data?.status !== 'authenticated' && resp.data?.status !== 'password_reset') {
        if (args.failure) args.failure();
        return;
      }

      context.commit('setAuthenticated', true);
      const profileResp = await (args.api || Api).member.profile.get();

      if (profileResp.data?.organization_id !== window.organization_id) {
        context.commit('setAuthenticated', false);
        context.dispatch('setProfileAndTimeout', null);

        if (args.failure) args.failure();
        return;
      }

      context.dispatch('setProfileAndTimeout', profileResp.data);
      SegmentService.forParent(window.analytics).identifyMember(profileResp.data);
      if (args.success) args.success(profileResp.data);
    },
  },

  state: defaultState,

  getters: {
    hasFamilyFacingFormSchemas: (state) => !!state.familyFacingFormSchemas?.length,
    hasFamilyRequestableFormSchemas: (state) => !!state.familyRequestableFormSchemas?.length,
    isAuthenticatedRegisteredParent: (state) => {
      // TODO: Refine our handling of auth state vs profile
      if (state?.is_authenticated && state?.is_parent && !state?.is_anonymous) return true;

      return (
        state?.profile?.is_authenticated &&
        state?.profile?.is_parent &&
        !state?.profile?.is_anonymous
      );
    },
  },

  mutations: {
    ...mutations,

    setExpandAppBarSmAndDown(state, val) {
      state.expandAppBarSmAndDown = val;
    },

    setNewMessage(state, val) {
      state.newMessage = val;
    },

    setProfile(state, profile) {
      state.profile = profile;
      if (profile) {
        if (profile.default_locale) {
          state.default_locale = profile.default_locale;
        }
        state.is_anonymous = profile.is_anonymous;
        state.is_parent = profile.is_parent;
      } else {
        state.is_anonymous = null;
        state.lists = null;
      }
    },

    setAnonymous(state, val) {
      state.is_anonymous = val;
    },

    setAuthenticated(state, val) {
      state.is_authenticated = val;
    },

    setSchemas(state, schemas) {
      state.schemas = schemas;

      if (schemas) {
        // Pull family facing schemas + order them alphabetically by name
        const familyFacingSchemas = Object.values(schemas).filter(
          (schema) => schema.data_type === 'Form' && schema.meta.family_facing?.enabled,
        );
        state.familyFacingFormSchemas = _.orderBy(
          familyFacingSchemas,
          [(schema) => schema.name.toLowerCase()],
          ['asc'],
        );

        // Pull family requestable schemas from already ordered family facing schemas
        state.familyRequestableFormSchemas = Object.values(familyFacingSchemas).filter(
          (schema) => schema.meta.family_facing.family_requestable,
        );
      }
    },

    resetState(state) {
      if (import.meta.env.NODE_ENV !== 'test')
        throw new Error('resetState should not be called in production');

      Object.assign(state, defaultState);
    },

    /* eslint no-param-reassign: ["error", { "props": false }] */
    // resetTimeout: _.throttle((state) => {
    //   if (!!state.userSessionTimeout && state.is_authenticated && !state.is_anonymous) {
    //     Api.member.session.get('parent', (resp) => {
    //       if (resp.data?.status === 'authenticated') state.userSessionActionTimestamp = new Date();
    //     });
    //   }
    // }, 15000),

    resetTimeout() {
      return false;
    },
  },
};

export default createStore(definition);
